import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PropertiesService } from '../content/sections/services/properties-services';
import { IProperties } from '../content/sections/interfaces/IProperties';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { EnvironmentsService } from '../content/sections/services/environments-service';
import { IEnvironments } from '../content/sections/interfaces/IEnvironments';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public enviroment: string;
  public templateVersion: string;
  public templateName: string;
  public version:string;

  constructor(
    private propertiesService:PropertiesService,
    private environmentsService:EnvironmentsService
  ) { 
    this.enviroment = environment.title;
    this.templateVersion = environment.templateVersion;
    this.templateName = environment.templateName;
  }

  ngOnInit() {
    this.GetAppVersion(); 
  }

  GetAppVersion() {
    this.propertiesService.GetPropertyByName('APP_VERSION').subscribe(
     (result: TransactionResult<IProperties[]>) => {
       if (result.success) {
         this.version = result.data[0].property_value;
       }
     }
   );
   this.GetEnvironment();   
  }

  GetEnvironment() {
    this.environmentsService.GetActiveEnvironment().subscribe(
    (result: TransactionResult<IEnvironments[]>) => {
      if (result.success) {
        this.enviroment = result.data[0].description;
      }
    }
  );
  }

}
